window.TUCBackgroundManager = BackgroundManager.extend({
    showMenu: function() {
        TweenMax.to(this.$backgroundContainer, 0.3, {
            left: "70px"
        });
    }
});
